import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import {
    Container,
    Typography,
    Box,
    Paper,
    Grid,
    TextField,
    Button,
    Divider,
    Alert
} from '@mui/material';
import { Reservation } from '../../types';

const PaymentReservation: React.FC = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const reservation = location.state?.reservation as Reservation;
    const [cardNumber, setCardNumber] = useState('');
    const [expiryDate, setExpiryDate] = useState('');
    const [cvv, setCvv] = useState('');
    const [error, setError] = useState('');

    if (!reservation) {
        return (
            <Container maxWidth="md" sx={{ mt: 4 }}>
                <Alert severity="error">Aucune réservation trouvée</Alert>
            </Container>
        );
    }

    const handlePayment = () => {
        // Validation des champs
        if (!cardNumber || !expiryDate || !cvv) {
            setError('Veuillez remplir tous les champs');
            return;
        }

        // Simulation de paiement réussi
        setTimeout(() => {
            navigate('/payment/success', {
                state: {
                    message: 'Paiement effectué avec succès',
                    reservation
                }
            });
        }, 1000);
    };

    return (
        <Container maxWidth="md" sx={{ mt: 4, mb: 4 }}>
            <Paper elevation={3} sx={{ p: 4 }}>
                <Typography variant="h4" component="h1" gutterBottom>
                    Paiement de la réservation
                </Typography>

                <Box sx={{ mb: 4 }}>
                    <Typography variant="h6" gutterBottom>
                        Détails de la réservation
                    </Typography>
                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={6}>
                            <Typography>Date: {new Date(reservation.date).toLocaleDateString('fr-FR')}</Typography>
                            <Typography>Heure: {reservation.sessionTime}</Typography>
                            <Typography>Activité: {reservation.activity}</Typography>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <Typography>Client: {reservation.firstName} {reservation.lastName}</Typography>
                            <Typography>Email: {reservation.email}</Typography>
                            <Typography>Téléphone: {reservation.phone}</Typography>
                        </Grid>
                    </Grid>
                </Box>

                <Divider sx={{ my: 4 }} />

                <Typography variant="h6" gutterBottom>
                    Informations de paiement
                </Typography>

                <Grid container spacing={3}>
                    <Grid item xs={12}>
                        <TextField
                            fullWidth
                            label="Numéro de carte"
                            value={cardNumber}
                            onChange={(e) => setCardNumber(e.target.value.replace(/\D/g, '').slice(0, 16))}
                            error={!!error}
                            helperText={error}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <TextField
                            fullWidth
                            label="Date d'expiration (MM/AA)"
                            value={expiryDate}
                            onChange={(e) => setExpiryDate(e.target.value.replace(/\D/g, '').slice(0, 4))}
                            error={!!error}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <TextField
                            fullWidth
                            label="CVV"
                            value={cvv}
                            onChange={(e) => setCvv(e.target.value.replace(/\D/g, '').slice(0, 3))}
                            error={!!error}
                        />
                    </Grid>
                </Grid>

                <Box sx={{ mt: 4, display: 'flex', justifyContent: 'space-between' }}>
                    <Button
                        variant="outlined"
                        onClick={() => navigate(-1)}
                    >
                        Retour
                    </Button>
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={handlePayment}
                    >
                        Payer
                    </Button>
                </Box>
            </Paper>
        </Container>
    );
};

export default PaymentReservation;